import React from "react";
import {Provider} from "react-redux";
import OffersForMultipleBlueprintImages from "./OffersForMultipleBlueprintImages";
import {getStore} from "../../reducers/cart_icon_reducer";

const OffersForMultipleBlueprintImagesWithProvider = (props) => {
  return (
    <Provider store={getStore(props)}>
      <OffersForMultipleBlueprintImages {...props}/>
    </Provider>
  );
};

export default OffersForMultipleBlueprintImagesWithProvider;
